import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import TweenLite from "gsap/TweenLite";
import { Back } from "gsap";

import "./CityCreation.scss";

export default class CityCreation extends PureComponent {
  constructor() {
    super();

    this.state = {
      creationData: {
        cityName: "",
        purpose: "",
        siteName: "",
        configNumber: 1,
        cityColor: "",
        gameCode: "",
      },
      requestSent: false,
      cityNameLabel: "City Name"
    };
  }

  handleFocus = event => {
    const el = event.target.parentElement;
    const an = el.children[0];

    TweenLite.to(an, 0.1, { y: 0, autoAlpha: 1 });
  };

  handleBlur = event => {
    const el = event.target.parentElement;
    const an = el.children[0];

    TweenLite.to(an, 0.075, {
      y: 5,
      autoAlpha: 0,
      ease: Back.linear,
      delay: 0.025
    });
  };

  onChange = e => {
    let { name, value } = e.target;
    console.log(name + " " + value);
    if (name === "cityName") {
      if (value.match(/[^a-zA-Z0-9]/g)) {
        value = value.replace(/[^a-zA-Z0-9]/g, "");
      }
      if (value.length < 5 || value.length > 32) {
        this.setState({
          cityNameLabel:
            "You must input at least 5 characters and less than 32 characters"
        });
      } else {
        this.setState({
          cityNameLabel: "City Name"
        });
      }
    }

    this.setState(prevState => {
      return {
        creationData: {
          ...prevState.creationData,
          [name]: value
        }
      };
    });
  };

  onColorPick = e => {
    let value = e.target.getAttribute('value')
      console.log(value)
      this.setState(prevState => {
        return {
          creationData: {
            ...prevState.creationData,
            cityColor: value
          }
        };
      });
  }

  onCreateCity = e => {
    e.preventDefault();
    this.setState(prevState => {
      return { requestSent: !prevState.requestSent };
    });

    this.props.createCity(this.state.creationData).then(res => {
      this.setState(prevState => {
        return { requestSent: !prevState.requestSent };
      });

      res &&
        this.setState(() => {
          return {
            creationData: {
              cityName: "",
              purpose: "",
              siteName: "",
              configNumber: 1,
              cityColor: "",
              gameCode: "",
            }
          };
        });
    });
  };

  render() {
    const { cityName, purpose, siteName, gameCode } = this.state.creationData;
    const availableCodes = this.props.availableCodes || [];
    const codesLoaded = this.props.codesLoaded;
    if (codesLoaded && availableCodes.length === 0) {
      return (
        <div className="flex flex-items-center flex-justify-center input__container ">
          <div className="metrics__container">
            <div className={`metrics__wrapper`}>
              <h3 className="creationHeader">Create a New City</h3>
              <div style={{ padding: 20, background: "#fff3cd", border: "1px solid #ffeeba", borderRadius: 4 }}>
                <p><strong>No codes available for a new city.</strong></p>
                <p>None of your DMS Sims game codes can be used to create a new city right now.
                  This is either because you've already used each of your codes
                  (each code creates one game in one sim), or your codes have expired or been revoked.</p>
                <p>Existing cities you created with codes that are still active continue to work normally.</p>
                <p>To get a new code, contact your DMS admin.</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="flex flex-items-center flex-justify-center input__container ">
        <div className="metrics__container">
          <div className={`metrics__wrapper`}>
            <h3 className="creationHeader">Create a New City</h3>

            <form
              className="signup_form"
              method="post"
              onSubmit={e => this.onCreateCity(e)}
            >
              <div className={`flex flex-wrap formRow`}>
                <div
                  className="formItemFull"
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <label
                    className="formLabel"
                    htmlFor="cityName"
                    style={
                      this.state.cityNameLabel !== "City Name"
                        ? { color: "red" }
                        : null
                    }
                  >
                    {this.state.cityNameLabel}
                  </label>
                  <input
                    type="text"
                    className="newCityInput"
                    name="cityName"
                    id="cityName"
                    placeholder="Enter a City Name (no spaces or special characters allowed)"
                    value={cityName}
                    onChange={e => this.onChange(e)}
                    required
                  />
                </div>
              </div>
              <div className={`flex flex-wrap formRow`}>
                <div
                  className="formItemFull"
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <label className="formLabel" htmlFor="purpose">
                    Purpose
                  </label>
                  <input
                    type="text"
                    className="newCityInput"
                    name="purpose"
                    id="purpose"
                    value={purpose}
                    onChange={e => this.onChange(e)}
                    placeholder="Where are you going to use this city?"
                    required
                  />
                </div>
              </div>

              <div className={`flex flex-wrap formRow`}>
                <div
                  className="formItemFull"
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <label className="formLabel" htmlFor="siteName">
                    Site Name
                  </label>
                  <input
                    type="text"
                    className="newCityInput"
                    name="siteName"
                    id="siteName"
                    value={siteName}
                    onChange={e => this.onChange(e)}
                    placeholder="Enter your Site Name"
                    required
                  />
                </div>
              </div>
              <div className={`flex flex-wrap formRow`}>
                <div className="formItemFull">
                  <label className="formLabel" htmlFor="gameCode">
                    Game Code
                  </label>
                  <select
                    className="newCityInput"
                    name="gameCode"
                    id="gameCode"
                    value={gameCode}
                    onChange={e => this.onChange(e)}
                    required
                  >
                    <option value="">-- pick a code --</option>
                    {availableCodes.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.code} ({c.days_remaining}d remaining)
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <select
                className="configCard"
                name="configNumber"
                value={this.state.creationData.configNumber}
                onChange={e => this.onChange(e)}
              >
                {this.props.config.map((config, index) => (
                  <option key={index} value={config.name}>
                    {config.description}
                  </option>
                ))}
              </select>
              <h3 style={{ marginTop: "10px", fontFamily: `"Helvetica Neue", Helvetica, Arial, sans-serif` }}>Choose an optional color to group by: </h3>
              <div className="flex flex-justify-between" style={{ marginTop: "10px" }}>
              {this.props.colors.map((color, index) => (
                <div
                  key={index}
                  name={color.name}
                  value={color.color}
                  style={{ background: color.color}}
                  className={this.state.creationData.cityColor === color.color ? "selectedColorPicker" : "colorPicker"}
                  onClick={e => this.onColorPick(e)}
                 />
              ))}
              </div>
              <div className=" flex flex-justify-end">
                <button
                  type="submit"
                  className="button create"
                  disabled={this.state.requestSent ? "disabled" : ""}
                >
                  {this.state.requestSent ? "Creating . . ." : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

CityCreation.propTypes = {
  createCity: PropTypes.func.isRequired
};
